export default __webpack_public_path__ + "static/media/data_¿duracion.34e65fad.png";